(() => {
  if (window.jdPreorderPresentationBound) return;
  window.jdPreorderPresentationBound = true;
  function tidy() {
    document.querySelectorAll('.lb-addon-cont').forEach(offer => {
      const title = offer.querySelector('.lb-addon-title');
      if (!title || !/rush/i.test(title.textContent)) return;
      offer.classList.add('jd-rush-native');
      Array.from(title.childNodes).filter(node => node.nodeType === 3).forEach(node => {
        const clean = node.textContent.replace(/^\s*🚚\s*/, '');
        if (clean !== node.textContent) node.textContent = clean;
      });
      if (!title.querySelector('[data-jd-rush-icon]')) {
        const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        icon.setAttribute('data-jd-rush-icon', '');
        icon.setAttribute('class', 'jd-rush-native__icon');
        icon.setAttribute('viewBox', '0 0 24 24');
        icon.setAttribute('aria-hidden', 'true');
        icon.setAttribute('focusable', 'false');
        icon.setAttribute('fill', 'none');
        icon.setAttribute('stroke', 'currentColor');
        icon.setAttribute('stroke-width', '1.6');
        icon.setAttribute('stroke-linecap', 'round');
        icon.setAttribute('stroke-linejoin', 'round');
        icon.innerHTML = '<path d="M9 5h10v13H9zM9 9h10M14 5v4M3 8h3M1 12h5M3 16h3M12 14h4"/>';
        title.prepend(icon);
      }
    });
    document.querySelectorAll('[data-jd-preorder-notice]').forEach(notice => {
      const info = notice.closest('.product__info-container');
      info?.querySelectorAll('p, div, span').forEach(element => {
        if (element.closest('[data-jd-preorder-notice], [data-jd-maiv-purchase]')) return;
        if (!element.children.length && /^Standard Pre Order Shipping:/i.test(element.textContent.trim())) {
          if (element.style.display !== 'none') element.style.setProperty('display', 'none', 'important');
        }
      });
      info?.querySelectorAll('.product__description div[style]').forEach(element => {
        if (/This bundle includes.+currently available for pre-order/i.test(element.textContent)) {
          if (element.style.display !== 'none') element.style.setProperty('display', 'none', 'important');
        }
      });
      info?.querySelectorAll('.restock-rocket-preorder-description').forEach(element => {
        const details = Array.from(element.querySelectorAll('.preorder-detail-text'));
        const duplicate = details.length && details.every(detail => !detail.textContent.trim() || /^Standard Pre Order Shipping:/i.test(detail.textContent.trim()));
        if ((!element.textContent.trim() || duplicate) && element.style.display !== 'none') {
          element.style.setProperty('display', 'none', 'important');
        }
      });
    });
  }
  function consentFor(form) {
    return form?.querySelector('#restock-rocket-acknowledge-preorder');
  }
  function syncConsent() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
      const consent = consentFor(form);
      form.querySelectorAll('button[type="submit"][name="add"]').forEach(button => {
        const blocked = Boolean(consent && !consent.checked);
        button.classList.toggle('jd-preorder-consent-required', blocked);
        if (blocked && !button.hasAttribute('data-jd-consent-aria')) {
          button.dataset.jdConsentAria = button.getAttribute('aria-disabled') ?? '';
          button.setAttribute('aria-disabled', 'true');
        } else if (!blocked && button.hasAttribute('data-jd-consent-aria')) {
          const previous = button.dataset.jdConsentAria;
          if (button.getAttribute('aria-disabled') === 'true') {
            if (previous) button.setAttribute('aria-disabled', previous);
            else button.removeAttribute('aria-disabled');
          }
          delete button.dataset.jdConsentAria;
        }
      });
    });
  }
  function guardConsent(event) {
    const button = event.type === 'click' ? event.target.closest?.('button[type="submit"][name="add"]') : null;
    const form = event.type === 'submit' ? event.target : button?.form;
    const consent = consentFor(form);
    if (!consent || consent.checked) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    syncConsent();
    consent.focus();
  }
  window.addEventListener('click', guardConsent, true);
  window.addEventListener('submit', guardConsent, true);
  document.addEventListener('change', syncConsent);
  tidy();
  syncConsent();
  let scheduled = false;
  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; tidy(); syncConsent(); });
  }).observe(document.body, {childList: true, subtree: true});
})();
